import {storageProxy} from 'interactors/storageProxy';
import {VERSION_STORAGE_KEY as key} from '../config';
import {SetupDependencies} from '../types';

export function extractSavedVersion(di: SetupDependencies = {}): string {
  const {storage = storageProxy} = di;
  return storage.getItem(key);
}

export function isColdStart(): boolean {
  return !extractSavedVersion();
}
